module.exports = __webpack_public_path__ + "static/media/ws-click-and-collect-blue.78fd9b0a.svg";